import React, { useEffect, useState, useContext } from "react";
import * as yup from "yup";
import { Context } from "../../../context/globalContext";
import { useFormik } from "formik";
import { useStorage } from "../../hook/useStorage";
import { showWarningMessage } from "../../../helpers/swalAlert";
import {
  GET_SCHOOLS,
  GET_SPECIALTIES,
} from "../../../helpers/graphqlQueries";
import { NewsQueries } from "../../../helpers/GraphqlQueriesLib";
import {
  EDIT_USER_PROFILE_PG,
  EDIT_NAME_ROCKET,
  OTHER_SCHOOL,
  CREATE_USER_RECOMENDATION
} from "../../../helpers/graphqlMutations";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { Dropdown } from "semantic-ui-react";
import styled from "styled-components";
import imgUser from "../../../assets/images/sprites/avatar-person.svg";
import firebase from "firebase/app";
import "firebase/storage";
import Checkbox from "../../genericComponents/Checkbox";
import RadioButton from "../../genericComponents/RadioButton";
import { dataUrlFile } from "../../../helpers/utils";
import { useQuery } from "@apollo/client";
import BlueHero from "../../../assets/images/sprites/blueHero.jpg";
import editIcon from "../../../assets/images/icons/edit.png";
import ImageCrop from "../../genericComponents/ImageCrop";
import { Modal } from "antd";
import { Select } from "antd";
import { ButtonLoader } from "../../genericComponents/LoaderSubmitButton";
import { trackEvent, trackIdentity } from "../../../helpers/analytics";

function capitalizeFirstLetter(fullname) {
  return fullname.toLowerCase().replace(/\b./g, function (a) {
    return a.toUpperCase();
  });
}

const radioOptions = [
  "High School",
  "Undergraduate",
  "Applicant",
  "Growth Year",
  "Reapplicant",
  "Admitted",
  "Resident",
  "Fellow",
  "Practicing ",
  "Other",
];

const pronounsList = [
  "She/Her",
  "He/Him",
  "They/Them"
]

const pronounsOptions = pronounsList.map((option, index) => ({
  text: option,
  key: index,
  value: option,
}));

const pronounsOptionsRender = [
  <Select.Option key='She/Her'>She/Her</Select.Option>,
  <Select.Option key='He/Him'>He/Him</Select.Option>,
  <Select.Option key='They/Them'>They/Them</Select.Option>,
];

const careerList = [
  "Nursing",
  "Nurse Practitioner",
  "Physician Assistant",
  "Dental Hygienist",
  "Occupational Therapy",
  "Optometry",
  "Occupational Therapy",
  "Doctor of Chiropractic",
  "Doctors of naturopathic medicine",
  "Podiatric Medicine",
  "Healthcare Administration",
  "Certified Nursing Assistant",
  "Certified Medical Assistant",
  "Medical Scribe",
  "Speech-Language Pathology",
  "Veterinary Medicine",
  "Clinical Psychology",
  "Clinical Social Work",
  "Dental Assistant",
  "Doctor of Dental Surgery",
  "Doctor of Medicine in Dentistry",
  "Doctor of Pharmacy",
  "Registered Dietician",
  "Doctor of Osteopathic Medicine",
  "Doctor of Allopathic Medicine",
  "Phlebotomy",
  "Other",
];

const careerOptions = careerList.map((option, index) => ({
  text: option,
  key: index,
  value: option,
}));

const initialValues = {
  about: "",
  name: "",
  specialties: [],
  class_status: "",
  avatar: "",
  honors: [],
  medical_school: "",
  looking_for: [],
  can_offer: [],
  career: "",
  calendar_url: "",
  other_school: "",
  applicant_replicant: [],
  admitted_year:"",
  pronouns: [],
};

const initFile = {
  lastModified: 0,
  lastModifiedDate: "",
  name: "",
  size: 0,
  type: "",
  webkitRelativePath: "",
};

const schema = yup.object().shape({
  name: yup
    .string()
    .max(200, "Name must be at most 200 characters")
    .required("Name is a required field"),
  specialties: yup.array(),
  class_status: yup.string().required("Year in Program is a required field"),
  medical_school: yup.string().required("Medical school is a required field"),
  pronouns: yup.string(),
  avatar: yup.string(),
  honors: yup.array(),
  career: yup.string().required("Career is a required field"),
  about: yup.string(),
  calendar_url: yup
    .string()
    .matches(
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
      "Enter correct url!"
    ),
});

const honorsOptions = [
  { value: "Alpha Omega Alpha", label: "Alpha Omega Alpha" },
  {
    value: "Gold Humanism Honor Society",
    label: "Gold Humanism Honor Society",
  },
];
const applicantOptions = [
  { value: "Non-traditional", label: "Non-traditional" },
  {
    value: "International",
    label: "International",
  },
];

const admitedYear = [
  "1st Year",
  "2nd Year",
  "3rd Year",
  "4th Year",
  "5th Year",
];

const admitedYearOptions = admitedYear.map((option, index) => ({
  text: option,
  key: index,
  value: option,
}));

const lookingOrOffer = [
  "MENTORSHIP",
  "TUTORING",
  "COACHING",
  "NETWORKING",
  "STUDY GROUPS",
  "FRIENDSHIP",
  "ACCOUNTABILITY PARTNERING",
  "CLINICAL EXPERIENCE",
  "RESEARCH EXPERIENCE",
];

const emitEvents = (email, values, prevValues) => {
  trackEvent("ProfileEdited", { values, prevValues });
  trackIdentity(email,{
    "First Name":values.name?.split(' ')[0],
    "Offering":values.can_offer? values.can_offer.toString():"",
    "School": values.medical_school,
    "Student Status": values.class_status,
    "Career": values.career

  })

  if (!prevValues.about && values.about) {
    trackEvent("AboutFilled", {});
  }
 
  if (!prevValues.can_offer?.length>0 && values.can_offer?.length>0) {
    trackEvent("CanOfferFilled", { can_offer: values.can_offer });
    if (
      values.can_offer.some((ai) =>
        ["MENTORSHIP", "TUTORING", "COACHING"].includes(ai)
      )
    ) {
      trackEvent("NewMentor", { can_offer: values.can_offer });
    }
  }

  if (prevValues.can_offer !== values.can_offer) {
    if (
      !prevValues.can_offer.some((ai) =>
        ["MENTORSHIP", "TUTORING", "COACHING"].includes(ai)
      )
    ) {
      if (
        values.can_offer.some((ai) =>
          ["MENTORSHIP", "TUTORING", "COACHING"].includes(ai)
        )
      ) {
        trackEvent("NewMentor", { can_offer: values.can_offer });
      }
    }
  }

  if (!prevValues.looking_for?.length>0 && values.looking_for?.length>0) {
    trackEvent("LookingForFilled", { looking_for: values.looking_for });
  }
};

export default function EditProfileModal(props) {
  const { isShow, onHide } = props;
  const [specialities, setSpecialities] = useState([]);
  const [preferences, setPreferences] = useState([]);
  const [schools, setSchools] = useState([]);
  const [imageEdited, setImageEdited] = useState();
  const [loading, setLoading] = useState(false);
  const [prevValues, setPrevValues] = useState({});

  useQuery(GET_SPECIALTIES, {
    onCompleted: (data) =>
      setSpecialities(
        data.medical_specialties.map((speciality) => ({
          text: speciality.specialties_name,
          key: speciality.id,
          value: speciality.specialties_name,
        }))
      ),
  });

  useQuery(NewsQueries.GET_CATEGORIES, {
    onCompleted: (data) =>
      setPreferences(
        data.categories.map((category) => ({
          text: category.name,
          key: category.id,
          value: category.id,
        }))
      ),
  });

  useQuery(GET_SCHOOLS, {
    onCompleted: (data) =>
      setSchools(
        data.school_programs.map((school, index) => ({
          text: school.school_name,
          key: school.index,
          value: school.school_name,
        }))
      ),
  });

  const {
    graphQLClient,
    state: { user },
    dispatch: { setUser },
  } = useContext(Context);

  const [imageState, setImageState] = useState(initFile);
  const {
    errors,
    handleChange,
    handleSubmit,
    values,
    setFieldValue,
    touched,
    resetForm,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      ...initialValues,
    },
    validationSchema: schema,
    onSubmit: submitHandle,
    
  });

  useEffect(() => {
    if (isShow) {
      const mappedPreferences = user.preferences.map(
        ({ category }) => category.id
      );
      
      
      setFieldValue("avatar", user.avatar || "");
      setFieldValue("about", user.about || "");
      setFieldValue("name", user.name || "");
      setFieldValue("class_status", user.class_status);
      setFieldValue("pronouns", user.pronouns|| "");
      setFieldValue("honors", user.honors || []);
      setFieldValue("specialties", user.specialties || []);
      setFieldValue("preferences", mappedPreferences || []);
      setFieldValue("looking_for", user.looking_for || []);
      setFieldValue("can_offer", user.can_offer || []);
      setFieldValue("medical_school", user.medical_school);

      setPrevValues((prevState) => ({...prevState, "avatar": user.avatar || ""}));
      setPrevValues((prevState) => ({...prevState, "about": user.about || ""}));
      setPrevValues((prevState) => ({...prevState, "name": user.name || ""}));
      setPrevValues((prevState) => ({...prevState, "class_status": user.class_status}));
      setPrevValues((prevState) => ({...prevState, "pronouns": user.pronouns || ""}));
      setPrevValues((prevState) => ({...prevState, "honors": user.honors || []}));
      setPrevValues((prevState) => ({...prevState, "specialties": user.specialties || []}));
      setPrevValues((prevState) => ({...prevState, "preferences": mappedPreferences || []}));
      setPrevValues((prevState) => ({...prevState, "looking_for": user.looking_for || []}));
      setPrevValues((prevState) => ({...prevState, "can_offer": user.can_offer || []}));
      setPrevValues((prevState) => ({...prevState, "medical_school": user.medical_school}));
      
      if (user.career) {
        setFieldValue("career", user.career);
      }
      if ((user.class_status === "Applicant"||user.class_status === "Reapplicant")&&user.applicant_replicant){
        setFieldValue("applicant_replicant", user.applicant_replicant);
      }
      if (user.class_status === "Admitted" && user.admitted_year){
        setFieldValue("admitted_year", user.admitted_year);
      }

      if (user.calendar_url) {
        setFieldValue("calendar_url", user.calendar_url);
      }
      setImageEdited(null);
      //console.log('uservaluews',values, prevValues)
    }
  }, [isShow, user]);

  const image_preview = useStorage(`avatars/${user.avatar}`);

  async function submitHandle(values) {
    setLoading(true);
    const selectedPreferences = values.preferences.map((value) => ({
      id_category: value,
      user_email: user.email,
    }));

    const variables = {
      avatar: values.avatar,
      about: values.about,
      email: user.email,
      name: capitalizeFirstLetter(values.name),
      class_status: values.class_status.toString(),
      pronouns: values.pronouns,
      honors: values.honors,
      specialties: values.specialties,
      medical_school: values.medical_school,
      can_offer: values.can_offer,
      looking_for: values.looking_for,
      career: values.career,
      calendar_url: values.calendar_url,
      applicant_replicant: values.applicant_replicant,
      admitted_year: values.admitted_year,
      preferences: selectedPreferences,
    };

    try {
      await graphQLClient.mutate({ mutation: EDIT_USER_PROFILE_PG, variables});

      if(prevValues.name!==values.name){
        //console.log('cambio de nombre Rocket')
        await graphQLClient.mutate({
          mutation: EDIT_NAME_ROCKET,
          variables: {email:user.email, name:values.name},
        });
      }

      emitEvents(user.email, values, prevValues);

      delete variables["preferences"];
      variables.preferences = preferences
        .filter((preference) => values.preferences?.includes(preference.value))
        .map((preference) => ({
          category: { id: preference.value, name: preference.text },
        }));

      setUser({ ...user, ...variables });
      if (values.other_school) {
        await graphQLClient.mutate({
          variables: {
            school_name: values.other_school,
            user: user.email.trim().toLowerCase(),
          },
          mutation: OTHER_SCHOOL,
        });
      }

      const resMutation = await graphQLClient.mutate({
        variables: {
          career: values.career,
          school: values.other_school,
          can_offer:values.can_offer,
          looking_for:values.looking_for,
          email: user.email.trim().toLowerCase(),
          username:user.username,
          applicant_replicant: values.applicant_replicant,
          admitted_year: values.admitted_year
        },
        mutation: CREATE_USER_RECOMENDATION,
      });
      //console.log('resMutation', resMutation)
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
    onHide();
  }

  const onHandleChangeAvatar = (event) => {
    const file = event.target.files[0];
    if (event.target.value !== "") {
      const { type } = file;
      if (
        type.endsWith("jpeg") ||
        type.endsWith("png") ||
        type.endsWith("jpg") ||
        type.endsWith("raw")
      ) {
        if (file.size / 1024 / 1024 < 5) {
          setImageState(file);
        } else {
          showWarningMessage("You are uploading an file larger than 5Mb!");
        }
      } else {
        showWarningMessage(
          "Make sure you are uploading a file of .png / .jpg / .jpeg / .raw format!"
        );
      }
    }
  };

  async function onCropDone(imageBase64, name) {
    try {
      setImageState(initFile);
      const image = dataUrlFile(imageBase64, name);
      await firebase.storage().ref(`avatars/${name}`).put(image);
      setFieldValue("avatar", name);
      setImageEdited(imageBase64);
    } catch (error) {
      console(error);
    }
  }

  const onCropCancel = () => {
    setImageState(initFile);
  };

  function selectTag(e, prevValue, tag) {
    e.preventDefault();
    let newValue = [...prevValue];
    const index = newValue.indexOf(tag);
    if (index > -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(tag);
    }
    return newValue;
  }

  return (
    <ModalContentTotal
      footer={null}
      title='Edit Profile'
      visible={isShow}
      onCancel={onHide}
      width={1000}
    >
      <ModalContent>
        <FormContainer onSubmit={handleSubmit}>
          <Column50Center>
            <Divider header />
            <HeaderUserInfoContainer>
              {imageState.name !== "" ? (
                <ImageCrop
                  onCropCancel={onCropCancel}
                  onCropDone={onCropDone}
                  imageSrc={imageState}
                  size={120}
                />
              ) : imageEdited ? (
                <ProfileImage alt='preview' src={imageEdited} />
              ) : image_preview ? (
                <ProfileImage alt='preview' src={image_preview} />
              ) : (
                <ProfileImage alt='preview' src={imgUser} />
              )}
              <EditIconCont for='file-input'>
                <img src={editIcon} />
              </EditIconCont>
              <InputFile
                id='file-input'
                type='file'
                onChange={onHandleChangeAvatar}
              />
              <UserInfo>
                <Name pronouns={user.pronouns}>{user.name}</Name>
                <Info>{user.username}</Info>
                <Info>{user.medical_school}</Info>
              </UserInfo>
            </HeaderUserInfoContainer>

            <Divider />
            <FormSection style={{ justifyContent: "space-between" }}>
              <FormSection style={{ width: "57%" }}>
                <Subtitle>Full Name</Subtitle>
                <Input
                  name='name'
                  value={values.name}
                  type='text'
                  placeholder='Enter your full name'
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("name", true)}
                />
                {touched.name && errors.name && (
                  <ErrorMsg>{errors.name}</ErrorMsg>
                )}
              </FormSection>

              <FormSection style={{ width: "43%" }}>
                <NotRequiredSubtitle>Pronouns</NotRequiredSubtitle>
                {/* <Select
                  mode='tags'
                  allowClear
                  placeholder='Select Pronoun'
                  style={{ width: "100%", height: "35px", lineHeight: 2.2 }}
                  value={values.pronouns}
                  onChange={(data) => console.log("pronouns", data)}
                  onBlur={() => setFieldTouched("pronouns", true)}
                >
                  {pronounsOptionsRender}
                </Select> */}
                <CustomDropdown
                  placeholder='Select Pronoun'
                  fluid
                  search
                  selection
                  
                  options={pronounsOptions}
                  onChange={(_, data) => setFieldValue("pronouns", data.value)}
                  onBlur={() => setFieldTouched("pronouns", true)}
                  value={values.pronouns}
                />
                {errors.pronouns && touched.pronouns && (
                  <ErrorMsg>{errors.pronouns}</ErrorMsg>
                )}
              </FormSection>
            </FormSection>
            <Divider />
            <FormSection>
              <Subtitle>Bio</Subtitle>
              <TextArea
                placeholder='Some ideas:
              What has been challenging about your journey to medicine?
              Why did you choose your desired career?
              Fun fact 😃'
                value={values.about}
                rows={6}
                name='about'
                onChange={handleChange}
              />
              {touched.about && errors.about && (
                <ErrorMsg>{errors.about}</ErrorMsg>
              )}
            </FormSection>
            <Divider />
            <FormSection>
              <Subtitle>Career or desired career</Subtitle>
              <CustomDropdown
                placeholder='Select Career'
                fluid
                search
                selection
                options={careerOptions}
                onChange={(_, data) => setFieldValue("career", data.value)}
                onBlur={() => setFieldTouched("career", true)}
                value={values.career}
              />
            </FormSection>
            <Divider />
            {values.career.includes("Doctor of Allopathic Medicine") ||
            values.career.includes("Doctor of Osteopathic Medicine") ? (
              <>
                <FormSection>
                  <NotRequiredSubtitle>Medical Speciality</NotRequiredSubtitle>
                  <CustomDropdown
                    placeholder='Select Speciality'
                    fluid
                    search
                    selection
                    multiple
                    options={specialities}
                    onChange={(_, data) =>
                      data.value.length < 4
                        ? setFieldValue("specialties", data.value)
                        : null
                    }
                    onBlur={() => setFieldTouched("specialties", true)}
                    value={values.specialties?values.specialties:[]}
                  />
                </FormSection>
                {errors.specialties && touched.specialties && (
                  <ErrorMsg>{errors.specialties}</ErrorMsg>
                )}
                <Divider />
              </>
            ) : null}
            <FormSection>
              <Subtitle>School</Subtitle>
              <CustomDropdown
                placeholder='Select School'
                fluid
                search
                selection
                options={schools}
                onChange={(_, data) =>
                  setFieldValue("medical_school", data.value)
                }
                onBlur={() => setFieldTouched("medica_school", true)}
                value={values.medical_school}
              />
              {values.medical_school === "Other" && (
                <Input
                  type='text'
                  onChange={handleChange}
                  placeholder='Enter School Name'
                  name='other_school'
                />
              )}
            </FormSection>
            {errors.medical_school && touched.medical_school && (
              <ErrorMsg>{errors.medical_school}</ErrorMsg>
            )}
            <Divider />

            <FormSection>
              <Subtitle>Class Status</Subtitle>
              {radioOptions.map((value) => (
                <CheckboxContainer key={value}>
                  <RadioButton
                    onChange={() => setFieldValue("class_status", value)}
                    label={value}
                    checked={values.class_status === value}
                  />
                </CheckboxContainer>
              ))}
            </FormSection>
            <Divider />

            {values.class_status === "Admitted" ? (
              <>
                <FormSection>
                  <Subtitle>Admitted Year</Subtitle>
                  <CustomDropdown
                    placeholder='Select Year'
                    fluid
                    search
                    selection
                    options={admitedYearOptions}
                    onChange={(_, data) =>
                      {//console.log(data.value)
                      setFieldValue(
                        "admitted_year",
                        data.value
                      )}
                    }
                    onBlur={() => setFieldTouched("admitted_year", true)}
                    value={values.admitted_year}
                  />
                </FormSection>
                <Divider />
              </>
            ) : null}

            {values.class_status === "Applicant" ||
            values.class_status === "Reapplicant" ? (
              <>
                {Array.isArray(values.applicant_replicant)
                  ? null
                  : setFieldValue("applicant_replicant", [])}
                <FormSection>
                  <NotRequiredSubtitle>
                    {values.class_status} type
                  </NotRequiredSubtitle>
                  {applicantOptions.map((option, index) => (
                    <CheckboxContainer key={index}>
                      <Checkbox
                        label={option.label}
                        checked={
                          !!values.applicant_replicant?.filter(
                            (e) => e === option.value
                          )?.length
                        }
                        onChange={() => {
                          const isChecked = !!values.applicant_replicant?.filter(
                            (e) => e === option.value
                          )?.length;
                          if (!isChecked)
                            setFieldValue("applicant_replicant", [
                              ...values.applicant_replicant,
                              option.value,
                            ]);
                          else
                            setFieldValue(
                              "applicant_replicant",
                              values.applicant_replicant?.filter(
                                (e) => e !== option.value
                              )
                            );
                        }}
                      />
                    </CheckboxContainer>
                  ))}
                </FormSection>
                <Divider />
              </>
            ) : null}
            {values.career?.includes("Doctor of Allopathic Medicine") ||
            values.career?.includes("Doctor of Osteopathic Medicine") ? (
              <>
                <FormSection>
                  <NotRequiredSubtitle>Honors Society</NotRequiredSubtitle>
                  {honorsOptions.map((option, index) => (
                    <CheckboxContainer key={index}>
                      <Checkbox
                        label={option.label}
                        checked={
                          !!values.honors.filter((e) => e === option.value)
                            .length
                        }
                        onChange={() => {
                          const isChecked = !!values.honors.filter(
                            (e) => e === option.value
                          ).length;
                          if (!isChecked)
                            setFieldValue("honors", [
                              ...values.honors,
                              option.value,
                            ]);
                          else
                            setFieldValue(
                              "honors",
                              values.honors.filter((e) => e !== option.value)
                            );
                        }}
                      />
                    </CheckboxContainer>
                  ))}
                </FormSection>
                <Divider />
              </>
            ) : null}

            <FormSection>
              <NotRequiredSubtitle>
                News & Media Preferences{" "}
              </NotRequiredSubtitle>
              <CustomDropdown
                placeholder='Select Categories'
                fluid
                search
                selection
                multiple
                options={preferences}
                onChange={(_, data) => setFieldValue("preferences", data.value)}
                onBlur={() => setFieldTouched("preferences", true)}
                value={values.preferences?values.preferences:[]}
              />
            </FormSection>
            {errors.preferences && touched.preferences && (
              <ErrorMsg>{errors.preferences}</ErrorMsg>
            )}
            <Divider />
            <FormSection>
              <NotRequiredSubtitle>I am looking for</NotRequiredSubtitle>
              <TagsContainer>
                {lookingOrOffer.map((r) => (
                  <LiTags
                    active={values.looking_for?.includes(r)}
                    onClick={(e) =>
                      setFieldValue(
                        "looking_for",
                        selectTag(e, values.looking_for, r)
                      )
                    }
                  >
                    <ATags>{r}</ATags>
                  </LiTags>
                ))}
              </TagsContainer>
            </FormSection>
            <Divider />
            <FormSection>
              <NotRequiredSubtitle>I can offer...</NotRequiredSubtitle>
              <TagsContainer>
                {lookingOrOffer.map((r) => (
                  <LiTags
                    active={values.can_offer?.includes(r)}
                    onClick={(e) =>
                      setFieldValue(
                        "can_offer",
                        selectTag(e, values.can_offer, r)
                      )
                    }
                  >
                    <ATags>{r}</ATags>
                  </LiTags>
                ))}
              </TagsContainer>
            </FormSection>

            {values.can_offer.some((ai) =>
              ["MENTORSHIP", "TUTORING", "COACHING"].includes(ai)
            ) ? (
              <>
                <Divider />
                <FormSection>
                  <NotRequiredSubtitle>Calendar Url</NotRequiredSubtitle>
                  <Input
                    value={values.calendar_url}
                    name='calendar_url'
                    placeholder='Enter your calendar Url'
                    onChange={handleChange}
                    onBlur={() => setFieldTouched("calendar_url", true)}
                  />
                  {touched.calendar_url && errors.calendar_url && (
                    <ErrorMsg>{errors.calendar_url}</ErrorMsg>
                  )}
                </FormSection>
              </>
            ) : null}
            <Divider />
            <FormSection>
              <ButtonsContainer>
                <ModalButton
                  onClick={() => onHide()}
                  background={ThemeProps.color.softPurple}
                >
                  Cancel
                </ModalButton>
                {/* <ModalButton
                  background={ThemeProps.color.gabaYellow}
                  type='submit'
                  active={false}
                  loading={loading}
                >
                  Update Profile
                </ModalButton> */}
                <ButtonLoader loading={loading}>Update Profile</ButtonLoader>
              </ButtonsContainer>
            </FormSection>
          </Column50Center>
        </FormContainer>
      </ModalContent>
    </ModalContentTotal>
  );
}

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
`;
const LiTags = styled.button`
  margin-top: 4px;
  margin-right: 12px;
  vertical-align: middle;
  padding: 8px 16px;
  border: none;
  outline: none;
  border-radius: 6px;
  background: ${(p) => (p.active ? "#7280DBAA" : "#7280DB3A")};
  cursor: pointer;
`;
const ATags = styled.p`
  color: ${ThemeProps.color.darkBlue};
  font-size: 1.1em;
  font-weight: bold;
`;

const inputFontStyle = `
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
`;
const HeaderUserInfoContainer = styled.div`
  display: flex;
  margin-bottom: 48px;
`;
const InputFile = styled.input`
  width: 0;
  visibility: hidden;
`;
const EditIconCont = styled.label`
  width: 32px;
  height: 32px;
  position: "absolute";
  margin-left: -24px;
  &:hover {
    cursor: pointer;
  }
`;
const ModalContentTotal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
`;
const ModalContent = styled.div`
  background-image: url(${BlueHero});
  background-size: 100% 215px;
  background-repeat: no-repeat;
  background-color: white;
  padding-bottom: 32px;
`;
const ProfileImage = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 50%;
`;
const FormContainer = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const Column50Center = styled.div`
  width: 60%;
`;
const Input = styled.input`
  width: 100%;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  font-size: 1.3em;
  padding: 6px 12px;
  border-radius: 4px;
  margin-right: 8px;
  height: 35px;
`;
const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid lightgray;
  margin: 16px 0;

  ${(p) =>
    p.header ? `border-bottom: 1px solid ${ThemeProps.color.gabaYellow};` : ""}
`;
const Subtitle = styled.p`
  width: 100%;
  color: rgb(17, 23, 65);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  margin-bottom: 16px;
  padding-left: 10px;
  position: relative;

  ${(p) =>
    !p.header
      ? `
  &::before {
    display: inline-block;
    content: '*';
    color: red;
    width: 8px;
    height: 8px;
    font-size: 30px;
    position: absolute;
    left: -7px;
  }
  `
      : "color: white;"}
`;
const CustomDropdown = styled(Dropdown)`
  min-height: 35px;
  height: 35px;
  border: 1px solid lightgray;
  border-radius: 5px;
  margin-right: 15px;
  padding-left: 10px;
  width: 100%;
  ${inputFontStyle}
`;

const FormSection = styled.div`
  flex-wrap: wrap;
  display: flex;
  label {
    margin-right: 25px;
    margin-top: 10px;
  }

  .react-datepicker-wrapper input {
    height: 40px;
    width: 136px;
    border: 1px solid lightgray;
    text-align: center;
    border-radius: 5px;
    margin-right: 15px;
  }

  .custom-date {
    width: 170px;
  }
`;

const NotRequiredSubtitle = styled.p`
  width: 100%;
  color: rgb(17, 23, 65);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  margin-bottom: 10px;
  padding-left: 10px;
  position: relative;
`;

const CheckboxContainer = styled.div`
  width: 50%;
`;

const ModalButton = styled.button`
  background: ${(p) => p.background};
  border-radius: 6px;
  height: 48px;
  color: ${ThemeProps.color.darkBlue};
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  width: 48%;
  border: none;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const UserInfo = styled.div`
  display: flex;
  margin-left: 20px;
  flex-direction: column;
`;

const Name = styled.h3`
  color: rgb(249, 249, 249);
  font-family: EksellDisplayMedium;
  font-size: 24px;
  letter-spacing: -0.3px;
  position: relative;

  &::after {
    display: inline-block;
    content: "${(p) => p.degree}";
    color: white;
    height: 8px;
    font-size: 15px;
    position: absolute;
    left: 100%;
    min-width: 200px;
  }
`;

const Info = styled.p`
  color: white;
`;

const ErrorMsg = styled.span.attrs({ className: "text-danger" })`
  margin-bottom: -16px;
  color: #f22;
`;
const TextArea = styled.textarea`
  width: 100%;
  height: 120px;
  resize: none;
  border-radius: 6px;
  border-color: #ccc;
  font-size: 1.2em;
  padding: 8px 12px;
  outline-color: #aaa;
`;
